import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import GovernanceGate from './GovernanceGate';
import AccountSetupGate from './AccountSetupGate';
import OptOutReaffirmGate from './OptOutReaffirmGate';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading while auth is initializing
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If no user, redirect to login and remember where they were trying to go
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  return (
    <GovernanceGate userId={user.id}>
      <AccountSetupGate>
        <OptOutReaffirmGate>
          {children}
        </OptOutReaffirmGate>
      </AccountSetupGate>
    </GovernanceGate>
  );
}






